<template>
    <div class="material" v-viewer>
        <div class="material-tit">
            上传材料
        </div>
        <div class="material-item" v-for="(item,index) in material">
            <div class="material-item-tit">
                <span>{{item.materialName}}</span>
                <span v-if="item.isRequire == '1'" class="material-item-tit-must">*</span>
                ：
                <p class="material-item-tit-tips" v-if="item.notUp">
                    根据您要提交的信息自动生成，请点击文件上方蓝色按钮确认文件中数据是否正确
                </p>
            </div>
            <div class="material-item-cont">
                <template v-if="item.list.length>0" v-for="(upItem,upIndex) in item.list">
                    <div class="material-item-cont-i" :class="upItem.fileType" :title="upItem.fileName">
                        <!--要件展示-->
                        <template>
                            <img v-if="upItem.fileType === 'img'" :src="upItem.path" :alt="upItem.fileName">
                        </template>
                        <!--要件控制-->
                        <template>
                            <Icon
                                v-if="!upItem.create"
                                title="删除"
                                class="material-item-cont-iBtn remove"
                                @click="removeUp(index,upIndex)"
                                type="md-remove-circle"/>
                            <a v-if="upItem.create"
                               :href="upItem.path"
                               title="下载"
                               target="_blank"
                               class="material-item-cont-iBtn download ivu-icon ivu-icon-ios-download"></a>
                        </template>
                        <div class="material-item-cont-i-name">{{upItem.fileName}}</div>
                    </div>
                </template>
                <div class="material-item-cont-i" v-if="!item.notUp">
                    <Upload
                        ref="upload"
                        :show-upload-list="false"
                        :on-success="(value,file)=> handleSuccess(item,value,file)"
                        :format="['jpg','jpeg','png','pdf','doc','docx','xls','xlsx']"
                        :max-size="717"
                        :on-error="handleError"
                        :on-format-error="handleFormatError"
                        :on-exceeded-size="handleMaxSize"
                        :before-upload="handleBeforeUpload"
                        :data="item"
                        multiple
                        type="drag"
                        :action="uploadAction()">
                        <Icon type="ios-cloud-upload-outline" style="color:#52c4f8" size="20"/>
                    </Upload>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">


    export default {
        name: 'upMaterial',
        props: {
            data: [Object, Array],
            materialList: {
                type: Array,
                default: function () {
                    return []
                }
            },
            uuid: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                material: []
            }
        },
        watch: {
            material(val) {
                this.update();
            },
        },
        mounted() {
            this.material = this.materialList.map(item => {
                let i = this.$utils.copyObject(item);
                i.list = [];
                return i
            })
        },
        methods: {
            /**
             * 文件上传成功
             * @param item
             * @param res
             * @param file
             */
            handleSuccess(item, res, file) {
                debugger
                this.$Spin.hide();
                let {materialId: clid, isRequire, materialName,uuid} = item;
                if (res.code === "0000000") {
                    debugger
                    let url = res.body;
                    let path = process.env.VUE_APP_FTP_URL + res.body;
                    let wjmc = res.body.split("/")[res.body.split("/").length - 1];
                    let fileType = this.getFileType(file.name);
                    // 放置文件数据
                    this.material = this.material.map(item => {
                        if (item.materialId === clid) {
                            item.list.push({
                                url,
                                clid,
                                isRequire,
                                path,
                                wjmc,
                                materialName,
                                fileName: file.name,
                                fileType,
                                uuid,
                            });
                        }
                        return item;
                    })

                } else {
                    this.$Notice.warning({
                        title: "文件上传失败",
                        desc: res.msg
                    });
                }
            },
            /**
             * 格式校验错误
             * @param file
             */
            handleFormatError(file) {
                this.$Spin.hide();
                this.$Notice.warning({
                    title: "文件格式不正确",
                    desc: file.name + " 文件格式不正确，请选择的图片/PDF/WORD/XLS。"
                });
            },
            /**
             * 文件尺寸过大
             * @param file
             */
            handleMaxSize(file) {
                this.$Spin.hide();
                const content = `<p>上传文件超过700KB,无法继续。</p>` +
                    `<p>您可以压缩文件大小后再次上传。</p>` +
                    `<p style="margin-top: 10px"><b>您可以通过以一下网站压缩您的图片大小：</b></p>` +
                    `<p><a href="https://tinypng.com/" target="_blank">tinypng</a>[免费使用]</p>` +
                    `<p><a href="https://www.jpeg.io/" target="_blank">jpegIo</a>[免费使用]</p>`;
                this.$Modal.info({
                    title: '上传文件大小超过限制',
                    content: content
                });
            },
            /**
             * 文件上传之前
             * @param file
             */
            handleBeforeUpload(file) {
                console.log(file);
                this.$Spin.show();

                // return new Promise(function (resolve, reject) {
                //     debugger
                //     const renameReportFile =new File([file],'newFileName.png',{type:file.type});
                //     console.log(renameReportFile);
                //     resolve(renameReportFile)
                // });
            },
            /**
             * 接口地址
             * @returns {string}
             */
            uploadAction() {
                return process.env.VUE_APP_API_URL + "/api/updateAndMergeFiles";
            },
            /**
             * 更新数据
             */
            update() {
                let list = this.data;
                // 回合子组件与父组件的数据
                this.material.map(item => {
                    list = [...list, ...item.list]
                });
                // 去重
                list = list.reduceRight((item, next) => {
                    list[next.url] ? '' : list[next.url] = true && item.push(next);
                    return item
                }, []);

                list.reverse();

                this.$emit('update:data', list);
                this.$forceUpdate();
            },
            /**
             * 删除上传
             * @param index
             * @param upIndex
             */
            removeUp(index, upIndex) {
                // 获取删除项目url
                const {url} = this.material[index].list[upIndex];
                // 获取url在父级位置
                const fileIndex = this.data.findIndex(item => item.url === url);
                if (fileIndex >= 0) {
                    // 在父级映射处删除
                    this.data.splice(fileIndex, 1)
                }
                // 在文件展示处删除
                this.material[index].list.splice(upIndex, 1);
                this.update();
            },
            /**
             * 判断文件类型
             * @param fileName
             * @returns {string}
             */
            getFileType(fileName) {
                let n = fileName.split('.');
                let t = n[n.length - 1];
                let type = "";
                if (t === 'jpg' || t === 'jpeg' || t === 'png') {
                    type = 'img'
                } else if (t === 'pdf') {
                    type = 'pdf'
                } else if (t === 'doc' || t === 'docx') {
                    type = 'doc'
                } else if (t === 'xls' || t === 'xlsx') {
                    type = 'xls'
                }
                return type
            },
            /**
             * 上传失败
             */
            handleError() {
                this.$Spin.hide();
                this.$Notice.error({
                    title: '文件上传失败',
                    desc: "请刷新后重试！",
                    duration: 20
                });

            },
            /**
             * 父级向此组件添加文件
             * @param fileObj
             */
            addFile(fileObj) {
                this.material = this.material.map(item => {
                    // item.list = [];
                    const {clid} = fileObj;
                    if (item.materialId == clid) {
                        item.list.push(fileObj);
                    }
                    return item;
                })
            }
        }
    }
</script>

<style lang="scss">
    .material {
        width: 100%;

        &-tit {
            line-height: 25px;
            font-size: 18px;
            border-left: 2px solid #2d8cf0;
            padding-left: 8px;
            margin-bottom: 5px;
        }

        &-item {
            width: 100%;

            &-tit {
                width: 100%;
                padding-top: 10px;
                padding-bottom: 5px;
                font-size: 15px;

                &-must {
                    font-size: 16px;
                    color: #ed4014;
                }

                &-tips {
                    font-size: 12px;
                    color: #ff9900;
                }
            }

            &-cont {
                width: 100%;
                display: flex;
                flex-wrap: wrap;

                &-i {
                    position: relative;
                    width: 120px;
                    height: 80px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-right: 10px;
                    border-radius: 4px;
                    overflow: hidden;
                    background-color: #eee;
                    border: 1px solid #eee;
                    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);

                    background-repeat: no-repeat no-repeat;
                    background-position: center 12px;

                    &.pdf {
                        background-image: url("../../static/img/com/pdf.png");
                    }

                    &.doc {
                        background-image: url("../../static/img/com/doc.png");
                    }

                    &.xls {
                        background-image: url("../../static/img/com/xls.png");
                    }

                    .ivu-upload {
                        width: 100%;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }

                    &Btn {
                        position: absolute;
                        cursor: pointer;
                        font-size: 30px;

                        &.remove {
                            top: 1px;
                            right: 1px;
                            color: #ed4014;

                            .create {
                                color: #c5c8ce;
                            }
                        }

                        &.download {
                            top: 1px;
                            right: 1px;
                            color: #2d8cf0;
                        }
                    }

                    &-name {
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 100%;
                        height: 20px;
                        line-height: 20px;
                        background-color: #fff;
                        color: #515a6e;
                        font-size: 12px;
                        padding: 0 5px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        -webkit-line-clamp: 1;
                        -webkit-box-orient: vertical;
                        word-break: break-all;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/upMaterial/upMaterialUuid.vue